import MergedImagesWrapper from "./MergedImagesWrapper";
import CropWrapper from "./CropWrapper";
import G from './Getters';
import { useStore } from 'react-redux';
import SvgImageFilter from "./SvgImageFilter";
import { computeFilterArgs } from './SvgImageFilter';
import ColorFilter from "./ColorFilter";
import { FigureChannelAdjustmentContext } from './Contexts';
import { useContext } from 'react';
import MergedImages from './MergedImages';
import { layersByChannelIdToLayers } from "./utils";

const SVG = true;

export default function LayoutValueImageSVG({
  node,
  value,
  annotationId,
  imgRef,
  width,
  height,
}){
  const store = useStore();
  const state = store.getState();

  // const { adjustment } = useContext(FigureChannelAdjustmentContext);

  let inlineCrop = G.getCropFromAnnotation(state,{annotationId,imageId:node.value.imageId});
  // console.log('$ic', inlineCrop, '$w', width);
  // let imageContent = (<div style={{ 

  //   //filter:'grayscale(1)',
  // }} className={
  //   `hoverable-sibling clickable full-width full-height`
  //   }>
  //   <CropWrapper {...{
  //     annotationId,
  //     inlineCrop,
  //     imageId:inlineCrop.imageId,
  //     imgRef,

  //     //WE NEED TEMPADJ:{}
  //     //otherwise, it gets applied twice
  //     temporaryAdjustments:{},
  //     //pxHeight:resolvedHeight,
  //     width,

  //   }}/>

  // </div>);




  // let filterId = Math.random();


  // debugger;
  // let { adjustments, grayscale } = G.getImage(state,value.imageId); 



  // let resolvedAdjustments = {
  //   ...adjustments,
  //   makeGrayscaleBeforeColorProjection:!grayscale
  // }


  // if( value.layers.length > 0 && value.layers[0] !== "none" ){
  //   resolvedAdjustments.colorProjection = value.layers.map(x => x.color);
  // }

  // let filterArgs = computeFilterArgs(
  //   resolvedAdjustments
  // );


  // filterArgs.filterId = filterId;


  // let svg = SVG && (<svg 

  //   colorInterpolationFilters={"sRGB"}


  //   class="full-dim">

  //   <SvgImageFilter filterArgs={filterArgs}/>

  //   {true && value.colorProjection && <ColorFilter colorProjection={value.colorProjection} filterId={filterId}/>}
  //   <foreignObject x="0" y="0" width={width} height={height} filter={`url(#${filterId})`}>
  //     {imageContent}
  //   </foreignObject>
  // </svg>)

  let layers = layersByChannelIdToLayers(value.layersByChannelId);

  return <MergedImagesWrapper toDraw={layers} crop={inlineCrop} annotationId={annotationId} />;

  /* return (

    <div style={{
      position:'relative',
    }} class="full-height full-width sg-row hoverable rel">


      {svg || imageContent}

      {true && <div style={{
        //outline:'5px solid #a6d3f7',
        zIndex:100,
        pointerEvents:'none'
      }} class="_visible-on-sibling-hover sg-row absolute-cover"/>}

      {false && <div class="absolute-cover" style={{background:'white', fontSize:6
      }}>
        <pre>
          {JSON.stringify(filterArgs,null,1)}
        </pre>
      </div>}

    </div> 
  ) */
}
